export default __webpack_public_path__ + "static/media/connecting-interpreter-1.19a3ab8a.svg";